import { Link } from "react-router-dom";
import logo from "@/assets/logo.webp";
import { OPEN_CONSENT_EVENT, OPEN_DNS_EVENT } from "@/components/CookieConsent";

const dispatchOpen = (event: string) => {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(event));
  }
};

const Footer = () => {

  return (
    <footer aria-label="Site footer" className="bg-foreground py-16 px-6 text-primary-foreground/85">
      <div className="mx-auto grid max-w-5xl gap-10 md:grid-cols-4 text-center md:text-left">
        <div className="md:col-span-2">
          <div className="flex flex-col items-center md:items-start gap-3">
            <Link
              to="/"
              aria-label="San Diego Coastal Guide homepage"
              className="inline-block"
            >
              <img
                src={logo}
                alt=""
                width={48}
                height={48}
                decoding="async"
                className="h-12 w-auto rounded-md object-contain"
              />
            </Link>
            <h3 className="font-display text-2xl font-semibold text-primary-foreground">
              San Diego Coastal Guide
            </h3>
          </div>
          <p className="font-body mt-3 text-sm leading-relaxed">
            A locally-written guide to San Diego's beaches, surf, tides, dining,
            trails, and coastal adventures — updated daily.
          </p>
        </div>

        <div>
          <h4 className="font-display text-sm font-semibold uppercase tracking-[0.2em] text-primary-foreground">
            Explore
          </h4>
          <ul aria-label="Explore links" className="mt-4 space-y-2 font-body text-sm">
            <li><Link to="/beaches" className="hover:text-primary-foreground transition-colors">Beaches</Link></li>
            <li><Link to="/right-now" className="hover:text-primary-foreground transition-colors">Best beach right now</Link></li>
            <li><Link to="/surf" className="hover:text-primary-foreground transition-colors">Surf</Link></li>
            <li><Link to="/tides" className="hover:text-primary-foreground transition-colors">Tides</Link></li>
            <li><Link to="/weather" className="hover:text-primary-foreground transition-colors">Weather</Link></li>
            <li><Link to="/dining" className="hover:text-primary-foreground transition-colors">Dining</Link></li>
            <li><Link to="/trails" className="hover:text-primary-foreground transition-colors">Trails</Link></li>
            <li><Link to="/culture" className="hover:text-primary-foreground transition-colors">Breweries & Museums</Link></li>
            <li><Link to="/guides" className="hover:text-primary-foreground transition-colors">Guides</Link></li>
            <li><Link to="/nature-calendar" className="hover:text-primary-foreground transition-colors">Nature Calendar</Link></li>
            <li><Link to="/blog" className="hover:text-primary-foreground transition-colors">Blog</Link></li>
            <li><Link to="/happening/archive" className="hover:text-primary-foreground transition-colors">Story archive</Link></li>
            <li><Link to="/spotted-today" className="hover:text-primary-foreground transition-colors">Spotted Today</Link></li>
            <li><Link to="/sandy-shoes" className="hover:text-primary-foreground transition-colors">Sandy Shoes Reel</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-sm font-semibold uppercase tracking-[0.2em] text-primary-foreground">
            About
          </h4>
          <ul aria-label="About and legal links" className="mt-4 space-y-2 font-body text-sm">
            <li><Link to="/about" className="hover:text-primary-foreground transition-colors">About us</Link></li>
            <li><Link to="/contact" className="hover:text-primary-foreground transition-colors">Contact</Link></li>
            <li><Link to="/privacy" className="hover:text-primary-foreground transition-colors">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-primary-foreground transition-colors">Terms of Service</Link></li>
            <li>
              <button
                type="button"
                onClick={() => dispatchOpen(OPEN_CONSENT_EVENT)}
                className="hover:text-primary-foreground transition-colors"
              >
                Cookie settings
              </button>
            </li>
            <li>
              <button
                type="button"
                onClick={() => dispatchOpen(OPEN_DNS_EVENT)}
                className="hover:text-primary-foreground transition-colors text-left"
              >
                Do Not Sell or Share My Personal Information
              </button>
            </li>
            
            <li><Link to="/events" className="hover:text-primary-foreground transition-colors">Events</Link></li>
            <li><Link to="/site-index" className="hover:text-primary-foreground transition-colors">Site index</Link></li>
          </ul>
        </div>
      </div>

      <div className="mx-auto mt-12 max-w-5xl border-t border-primary-foreground/20 pt-8 text-center font-body text-xs text-primary-foreground/80 space-y-2">
        <p>© {new Date().getFullYear()} San Diego Coastal Guide. All rights reserved.</p>
        <p>
          Hero photo by{" "}
          <a
            href="https://unsplash.com/@mylokaye"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Mylo Kaye's Unsplash profile (opens in new tab)"
            className="underline hover:text-primary-foreground/60 transition-colors"
          >
            Mylo Kaye
          </a>{" "}
          on{" "}
          <a
            href="https://unsplash.com"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Unsplash homepage (opens in new tab)"
            className="underline hover:text-primary-foreground/60 transition-colors"
          >
            Unsplash
          </a>
        </p>
        <p>
          Designed by&nbsp;a local San Diego Developer&nbsp;<a
            href="https://camberos-systems.com"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Camberos Systems website (opens in new tab)"
            className="underline hover:text-primary-foreground/60 transition-colors"
          >
            camberos-systems.com
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
